import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OutlookTourHost" */ "./lazyIndex"), { name: "OutlookTourHost" });

export const OutlookTourHost: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.OutlookTourHost);
